// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1UvPK","left":"styles_left__3mQ6Z"};